// Custom Font JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Validate Adobe Fonts is loaded
  const adobeFontsCss = document.querySelector('link[href*="use.typekit.net"]');
  if (!adobeFontsCss) {
    console.error('Adobe Fonts CSS is not loaded!');
  }
  
  // Force apply fonts to all text elements
  const allElements = document.querySelectorAll('body, h1, h2, h3, h4, h5, h6, p, a, button, input, select, textarea');
  allElements.forEach(element => {
    element.style.fontFamily = 'var(--font-primary)';
    element.style.fontDisplay = 'swap';
  });
  
  // Add a class to indicate font loading state
  document.documentElement.classList.add('fonts-loading');
  
  // Check if fonts are actually loaded
  document.fonts.ready.then(function() {
    const testElement = document.createElement('span');
    testElement.style.fontFamily = getComputedStyle(document.documentElement).getPropertyValue('--font-primary').trim();
    testElement.style.position = 'absolute';
    testElement.style.visibility = 'hidden';
    testElement.textContent = 'Test Font Loading';
    document.body.appendChild(testElement);
    
    // If font is loaded successfully
    document.documentElement.classList.remove('fonts-loading');
    document.documentElement.classList.add('fonts-loaded');
    
    // Log font loading status for debugging
    console.log('Fonts loaded successfully');
    
    // Clean up
    document.body.removeChild(testElement);
  }).catch(function(error) {
    console.error('Font loading failed:', error);
    document.documentElement.classList.remove('fonts-loading');
    document.documentElement.classList.add('fonts-failed');
  });
}); 